import * as RadixDialog from '@radix-ui/react-dialog';
import clsx from 'clsx';
import type { ReactNode } from 'react';
import styles from './Modal.module.scss';
export type ModalProps = {
  animationType?: 'fade' | 'fromBottom' | 'fromLeft' | 'fromRight' | 'fromTop';
  centeredContent?: boolean;
  className?: string;
  contentClassName?: string;
  isPopup?: boolean;
  overlay?: boolean;
  stopPropagation?: boolean;
  trigger?: ReactNode;
} & RadixDialog.DialogProps;
export const Modal = ({
  animationType = 'fade',
  centeredContent = true,
  children,
  className,
  contentClassName,
  isPopup,
  overlay = true,
  stopPropagation,
  trigger,
  ...dialogProps
}: ModalProps) => {
  return <RadixDialog.Root {...dialogProps} data-sentry-element="unknown" data-sentry-component="Modal" data-sentry-source-file="Modal.tsx">
      <RadixDialog.Trigger asChild data-sentry-element="unknown" data-sentry-source-file="Modal.tsx">{trigger}</RadixDialog.Trigger>
      <RadixDialog.Portal data-sentry-element="unknown" data-sentry-source-file="Modal.tsx">
        <RadixDialog.Overlay {...stopPropagation && {
        onClick: e => e.stopPropagation()
      }} asChild data-sentry-element="unknown" data-sentry-source-file="Modal.tsx">
          <div className={clsx(overlay && styles.overlay, styles.fade, 'modal', className, isPopup && styles.isPopup, centeredContent && styles.centered)}>
            <RadixDialog.Content asChild data-sentry-element="unknown" data-sentry-source-file="Modal.tsx">
              <div className={clsx(styles.content, styles[animationType], isPopup && styles.isPopup, contentClassName)}>
                {children}
              </div>
            </RadixDialog.Content>
          </div>
        </RadixDialog.Overlay>
      </RadixDialog.Portal>
    </RadixDialog.Root>;
};